import { useEffect, useState } from "react";

const getInitialTheme = () => {
    const stored = localStorage.getItem("theme");
    if (stored) return stored;

    const systemDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
    return systemDark ? "dark" : "light";
};

const ThemeToggle = () => {
    const [theme, setTheme] = useState(() => getInitialTheme());

    useEffect(() => {
        document.documentElement.setAttribute("data-theme", theme);
        localStorage.setItem("theme", theme);
    }, [theme]);

    const toggleTheme = () => {
        setTheme(prev => (prev === "light" ? "dark" : "light"));
    };

    return (
        <div
            className="theme-toggle"
            onClick={toggleTheme}
            title="Переключити тему"
        >
            {theme === "light" ? "☀️" : "🌙"}
        </div>
    );
};

const Footer = () => {
    return (
        <footer className="bg-dark text-white text-center py-3 flex-shrink-0 mt-auto" id="footer">
            <small>© {new Date().getFullYear()} Lava Studio</small>
            <div className="theme-toggle-wrapper">
                <ThemeToggle />
            </div>
        </footer>
    );
};

export default Footer;
